import { MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { PRODUCT_STATUS } from "../../../helpers/constants";
import { useDefaultProductStatus } from "../../../hooks/useDefaultProductStatus";
import { useProductStatuses } from "../../../services/productsService";
import { ProductStatusText } from "../../ProductsPage/ProductStatusText";

const disabledInputSx = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#010a1a",
    },
};

export const ProductStatusDropdown = (props) => {
    const { control, fieldName, disabled = false, forMultipleProducts=false } = props;

    const { data } = useProductStatuses();
    const { defaultStatus } = useDefaultProductStatus();

    const statuses = (data?.results || []).filter(
        (status) => status.status_name_eng !== PRODUCT_STATUS.NONE,
    );

    if (!statuses || !defaultStatus) {
        return null;
    }

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    value={forMultipleProducts ? field.value : field.value || defaultStatus.id}
                    select
                    fullWidth
                    disabled={disabled}
                    sx={disabled ? disabledInputSx : undefined}
                >
                    {statuses.map((status) => (
                        <MenuItem key={status.id} value={status.id}>
                            <ProductStatusText status={status} />
                        </MenuItem>
                    ))}
                    {forMultipleProducts && 
                        <MenuItem key={null} value={null}>
                                {"-"}
                        </MenuItem>
                    }
                </TextField>
            )}
        />
    );
};
